import { useI18n as vueUseI18n, type Composer } from 'vue-i18n';

import i18n, { type ExtendedComposer, storageKey, supportedLocales, isLocaleSupported } from '@/i18n';

/**
 * Enhanced i18n composable with locale persistence and additional utilities
 *
 * FEATURES:
 * - Locale persistence to localStorage via `setLocale`
 * - Works both inside and outside component context
 * - Extended with locale management helpers
 *
 * @returns {ExtendedComposer} Extended i18n composer with additional utilities
 */
export function useI18n(): ExtendedComposer {
    const instance = getCurrentInstance();

    const composer = instance ? vueUseI18n() : (i18n.global as unknown as Composer);

    /**
     * Set the current locale and persist to localStorage
     *
     * @param {string} langCode - Locale code (e.g., 'de', 'en')
     */
    const setLocale = (langCode: string) => {
        if(!isLocaleSupported(langCode)) return;

        composer.locale.value = langCode;

        localStorage.setItem(storageKey, langCode);
    };

    return {
        ...composer,
        supportedLocales,
        isLocaleSupported,
        setLocale,
    } as ExtendedComposer;
}